<template>
  <button
    class="icon"
    @click="$emit('click')"
  >
    &times;
  </button>
</template>

<script>
export default {
  name: 'CloseIcon'
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/modals/CloseIcon.scss";
</style>
